const Actions = {
  FETCH_REPORTS: "FETCH_REPORTS",
  FETCH_REPORTS_SUCCESS: "FETCH_REPORTS_SUCCESS",
  FETCH_REPORTS_FAILURE: "FETCH_REPORTS_FAILURE",
};

export default Actions;
